import React from 'react'
import Navbar from '../../components/Navbar'
import { Avatar, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useParams } from 'react-router-dom'
import Loading from '../../components/Loading'
import { useTranslation } from 'react-i18next';
import { useStudent } from '../../hooks/useStudent'

export default function ParentStudent() {
    const { id } = useParams()
    const { data, isLoading } = useStudent(id)
    const { t } = useTranslation()

    return (
        <Navbar>
            <Container sx={{ marginTop: "120px" }}>
                {
                    !isLoading ?
                        <Paper sx={{ marginY: "80px", padding: "40px 20px 20px" }}>
                            {
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>{t('Photo')}</TableCell>
                                                <TableCell>{t('name')}</TableCell>
                                                <TableCell>{t('Email')}</TableCell>
                                                <TableCell>{t('phone')}</TableCell>
                                                <TableCell>{t('gender')}</TableCell>
                                                <TableCell>{t('birth')}</TableCell>
                                                <TableCell>{t('nationality')}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>

                                            <TableRow key={`${process.env.REACT_APP_API}images/${data?.data?.image}`}>
                                                <TableCell>
                                                <Avatar
                      alt={data?.data?.name}
                      src={`${process.env.REACT_APP_API}images/${data?.data?.image}`}
                      sx={{ width: "80px", height: "80px", fontSize: "42px" }}
                    />
                                                </TableCell>
                                                <TableCell>{data?.data?.name}</TableCell>
                                                <TableCell>{data?.data?.email}</TableCell>
                                                <TableCell>{data?.data?.phoneNumber}</TableCell>
                                                <TableCell>{t(data?.data?.gender)}</TableCell>
                                                <TableCell>{data?.data?.dateOfBirth}</TableCell>
                                                <TableCell>{t(data?.data?.nationality)}</TableCell>
                                            </TableRow>

                                        </TableBody>
                                    </Table>
                                </TableContainer>

                            }
                        </Paper>
                        :
                        <Loading />
                }
            </Container>
        </Navbar>
    )
}
